import type { IAirportProducts, IHotelProduct, IParkingProduct } from '@nuxt-monorepo/ui/types';

interface blokFilter {
    sort: string;
    limit_results: number;
    filter: string[];
    product_type?: string;
    blacklist: string;
}

export function filterProducts(blok: blokFilter, products: IAirportProducts) {
    if (!products) return;
    switch (blok.product_type) {
        case 'HotelWithParking':
            if (products.hotelsWithParking) {
                return filterAndSortHotels(blok, products.hotelsWithParking);
            } else if (products.hotels) {
                return filterAndSortHotels(blok, products.hotels);
            }
            break;
        case 'Hotel':
            if (products.hotels) {
                return filterAndSortHotels(blok, products.hotels);
            }
            break;
        case 'Parking':
            if (products.parking) {
                return filterAndSortParking(blok, products.parking);
            }
            break;
    }
}

export const filterAndSortHotels = (blok: blokFilter, products: IHotelProduct[]) => {
    return products
        ?.filter((product: IHotelProduct) => {
            const hotelId = product.hotel_id || product.id;
            if (blok.blacklist && blok.blacklist.replace(/\s+/g, '').split(',').includes(String(hotelId))) return false;
            if (blok.filter.includes('has-reviews')) {
                if (product.overview.surveys_count === 0) return false;
                if (product.overview.surveys_count === null) return false;
            }
            if (blok.filter.includes('hide-expedia')) {
                if (product.info.provider === 'expedia') return false;
            }

            // Filter out non-reservable products (by default)
            if (!blok.filter.includes('allow-unreservable')) {
                const productReservable = product?.info.reservable || product.reservable;
                if (!productReservable) return false;
            }

            // Filter out products without price or with separated pricing (by default)
            const pricingInfo = product?.info.pricing || product.pricing;
            const avgPrice = product?.overview.prices?.avg || product?.avg_price;
            if (!blok.filter.includes('allow-no-price')) {
                if (!(avgPrice > 0 || pricingInfo === 'separated')) return false;
            }

            return true;
        })
        .sort((a: IHotelProduct, b: IHotelProduct) => {
            if (blok.sort === 'closest') {
                const aDistance = a.overview?.distance_to_airport || a.distance;
                const bDistance = b.overview?.distance_to_airport || b.distance;
                return aDistance - bDistance;
            } else if (blok.sort === 'furthest') {
                const aDistance = a.overview?.distance_to_airport || a.distance;
                const bDistance = b.overview?.distance_to_airport || b.distance;
                return bDistance - aDistance;
            } else if (blok.sort === 'high-rated') {
                return b.overview.rating_by_customers?.accurate - a.overview.rating_by_customers?.accurate;
            } else if (blok.sort === 'low-rated') {
                return a.overview.rating_by_customers?.accurate - b.overview.rating_by_customers?.accurate;
            }

            return 0;
        })
        .slice(0, blok.limit_results ? blok.limit_results : 100);
};

export const filterAndSortParking = (blok: any, products: IParkingProduct[]) => {
    return products
        ?.filter((product: IParkingProduct) => {
            if (blok.blacklist && blok.blacklist.replace(/\s+/g, '').split(',').includes(String(product.id)))
                return false;
            if (blok.filter.includes('has-reviews')) {
                if (product.ratings?.rating_count === 0) return false;
                if (product.ratings?.rating_count === null) return false;
            }
            return true;
        })
        .sort((a: IParkingProduct, b: IParkingProduct) => {
            if (blok.sort === 'closest') {
                return parseFloat(a.distance) - parseFloat(b.distance);
            } else if (blok.sort === 'furthest') {
                return parseFloat(b.distance) - parseFloat(a.distance);
            } else if (blok.sort === 'high-rated') {
                return parseFloat(b.ratings.rating) - parseFloat(a.ratings.rating);
            } else if (blok.sort === 'low-rated') {
                return parseFloat(a.ratings.rating) - parseFloat(b.ratings.rating);
            }
            return 0;
        })
        .slice(0, blok.limit_results ? blok.limit_results : 100);
};
